const SUFFIX = '<%@=';
const PREFIX = '=@%>';

export const START = `${SUFFIX}start${PREFIX}`;
export const END = `${SUFFIX}end${PREFIX}`;
export const DIVIDER = `${SUFFIX}divider${PREFIX}`;
export const NEW_LINE = `${SUFFIX}newline${PREFIX}`;

export const HIGHLIGHT_MARK_REG_EXP = new RegExp(`${START}|${END}`, 'g');
